<div class="flex flex-col gap-4 my-4">
  <span class="text-2xl font-semibold">5. Resumen y comentarios</span>
  <span>Revisa el contenido del protocolo y de tu adhesión e incluye al final las observaciones que consideres.</span>
  <span class="text-2xl font-semibold">Condiciones para la adhesión</span>
  @for (card of resumenCards; track card) {
    <app-description
      [title]="card.title"
      [description]="card.description"
      [linkText]="card.linkText"
      [subtitle]="card.subtitle"
      [action]="card.action"></app-description>
  }

  <hr />
  <div class="space-y-4">
    <!-- Encabezado -->
    <span class="text-2xl font-semibold block">Normativa</span>

    <!-- Tipo, Rango y Fecha en fila -->
    <div class="flex flex-wrap gap-6">
      @if (data?.type) {
        <div class="flex gap-2">
          <span class="font-bold">Tipo:</span>
          <span>{{ normativeEnum[data.type.toUpperCase()]['ES'] }}</span>
        </div>
      }

      @if (data?.range) {
        <div class="flex gap-2">
          <span class="font-bold">Rango:</span>
          <span>{{ data.range }}</span>
        </div>
      }

      @if (data?.date) {
        <div class="flex gap-2">
          <span class="font-bold">Fecha:</span>
          <span>{{ data.date | spanishDate }}</span>
        </div>
      }
    </div>

    <!-- Título de la normativa en columna -->
    @if (data?.title) {
      <div>
        <span class="font-bold block">Título de la normativa:</span>
        <span class="block">{{ data.title }}</span>
      </div>
    }

    <!-- Enlace de la normativa -->
    @if (data?.url) {
      <div class="flex gap-2">
        <span class="font-bold">Enlace de la normativa:</span>
        <a
          [href]="data.url"
          target="_blank"
          rel="noopener noreferrer"
          class="text-sky-700 hover:underline">
          {{ data.url }}
        </a>
      </div>
    }

    <!-- Tiempo vigencia -->
    @if (data?.effectiveDate) {
      <div class="flex gap-2">
        <span class="font-bold">Tiempo vigencia:</span>
        <span>
          {{ isOlderThan50Years(data.effectiveDate) ? (data.effectiveDate | spanishDate) : 'Indefinida' }}
        </span>
      </div>
    }
    <a
      role="button"
      (click)="goStepFNHandler(3)"
      class="text-sm text-sky-700 hover:underline mt-4">
      Modificar
    </a>
  </div>
  <hr />
  <div>
    <span class="text-2xl font-semibold block">Listado Rpt´s</span>
    <desy-table-advanced
      classes="min-w-full"
      idPrefix="table-with-all"
      [wrapper]="{ classes: 'overflow-x-auto' }">
      <desy-table-advanced-header>
        <desy-table-advanced-header-cell>
          <desy-content>Nombre</desy-content>
        </desy-table-advanced-header-cell>
        <desy-table-advanced-header-cell>
          <desy-content>Puesto</desy-content>
        </desy-table-advanced-header-cell>
        <desy-table-advanced-header-cell>
          <desy-content>Organismo</desy-content>
        </desy-table-advanced-header-cell>
        <desy-table-advanced-header-cell>
          <desy-content>Email</desy-content>
        </desy-table-advanced-header-cell>
      </desy-table-advanced-header>
      @for (c of data.rpts; track c.orgCode) {
        <desy-table-advanced-row [id]="c.orgCode">
          <desy-table-advanced-row-cell>{{ c.firstName }} {{ c.lastName }}</desy-table-advanced-row-cell>
          <desy-table-advanced-row-cell>{{ c.position }}</desy-table-advanced-row-cell>
          <desy-table-advanced-row-cell>{{ c.orgCode }}</desy-table-advanced-row-cell>
          <desy-table-advanced-row-cell>{{ c.mail }}</desy-table-advanced-row-cell>
        </desy-table-advanced-row>
      }
    </desy-table-advanced>
    <a
      role="button"
      (click)="goStepFNHandler(4)"
      class="text-sm text-sky-700 hover:underline mt-4">
      Modificar
    </a>
  </div>
  <span class="text-2xl font-semibold">Observaciones</span>
  <span>
    Indica aquí si deseas trasladar algún comentario adicional al responsable de la aprobación de la adhesión al
    protocolo de consulta.
  </span>
  <desy-textarea
    [classes]="'w-full'"
    [(ngModel)]="textAreaValue"
    [rows]="5"></desy-textarea>

  <div class="border-2 border-blue-500 flex items-center justify-between p-4">
    <div class="flex items-center justify-center w-10 h-10">
      <span
        class="ml-4 inline-flex items-center justify-center w-5 h-5 rounded-full bg-cyan-800 text-white text-xs cursor-pointer">
        <i
          class="pi pi-info"
          style="color: white; font-size: 0.6rem"></i>
      </span>
    </div>
    <span class="flex-1 text-left text-gray-700 ml-4">
      La adhesión debe ser aprobada por la persona responsable funcionalmente del conjunto de datos de cesión. Si el
      conjunto de datos tuviera datos sensibles, previamente será revisada por el/la delegado/a de protección de datos.
    </span>
  </div>
  <div>
    <span>
      Al hacer click en "Solicitar adhesión" aceptas los términos y condiciones que acabas de revisar en esta página.
    </span>
  </div>
  <app-buttons
    [label]="'Solicitar adhesión'"
    [classes]="'bg-primary-base text-white mt-4'"
    (click)="confirmSendData()" />
</div>
<p-confirmdialog />
